import React, { Component } from 'react'
import { connect } from 'shalala';
import { Guardian } from '@xaamin/guardian';
import { Link, Route } from 'react-router-dom';
import { Row, Col, Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useStore } from '../../store';
import CancelacionesUpload from './CancelacionesUpload';
import CancelacionesListComponent from './archivos/list/CancelacionesList';
import SearchByDatesAndKeyword from '../../shared/SearchByDatesAndKeyword';
import CancelacionesItemActions from './archivos/list/components/CancelacionesItemActions';

class CancelacionesList extends Component {

  state = {
    selectedRowKeys: [],
    selectedRows: []
  }

  componentDidMount() {
    window.setAppTitle('Cancelaciones');
  }

  handleOnRowSelectionChange = ({selectedRowKeys, selectedRows}) => {
    this.setState({
      selectedRowKeys,
      selectedRows
    });
  }

  handleOnRowClick = (data) => {
    this.props.history.replace({
      pathname: `/modulos/cancelaciones/${data.id}/info`,
      state: {
        data: {...data}
      }
    });
  }

  handleOnDateChange = (values) => {
    this.props.paginate(values);
  }

  handleOnKeywordChange = (search) => {
    this.props.paginate({ search });
  }

  render() {
    const { selectedRowKeys, selectedRows } = this.state;
    const { from, to, search } = this.props.pagination;

    return (
      <>
        <Row>
          <Col sm="auto" md="8">
            <div>
              { selectedRowKeys.length > 0 && (
                <div className="mr-3 d-inline-flex pb-1">
                  <CancelacionesItemActions
                    selectedRowKeys={ selectedRowKeys }
                    selectedRows={ selectedRows }
                    alignRight={ false }
                  />
                </div>
              )}

              { selectedRowKeys.length === 0 && (
                <SearchByDatesAndKeyword
                  from={ from }
                  to={ to }
                  search={ search }
                  onDateChange={ this.handleOnDateChange }
                  onKeywordChange={ this.handleOnKeywordChange }
                />
              )}
            </div>
          </Col>

          <Col sm="auto" md="4" className="text-right pb-2">
            { Guardian.allows('cancelacion.masiva.subir.archivo') && (
              <Button as={ Link } className="mr-2" to="/modulos/cancelaciones/archivos/upload">
                Subir archivo
              </Button>
            )}

            <Button variant="link"
              as={ Link }
              className="text-secondary"
              to="/modulos/cancelaciones/tickets"
            >
              Tickets { ' ' }
              <FontAwesomeIcon icon={ ['fas', 'chevron-right'] } />
            </Button>
          </Col>

        </Row>

        { Guardian.allows('cancelacion.masiva.listar.archivos') && (
          <CancelacionesListComponent
            onRowClick={ this.handleOnRowClick }
            selectedRowKeys={ selectedRowKeys }
            selectedRows={ selectedRows }
            onRowSelectionChange={ this.handleOnRowSelectionChange }
          />
        )}

        <Route path="/modulos/cancelaciones/archivos/upload" component={ CancelacionesUpload } />
      </>
    )
  }
}

const mapState = (store) => {
  return store.modulo.cancelaciones.archivos
}

const mapActions = (actions) => {
  return actions.modulo.cancelaciones.archivos;
}

export default connect(useStore, mapState, mapActions)(CancelacionesList)